import clsx from "clsx";
import { ModalDialog } from "components/modals/ModalDialog";

export const ImagePreviewButton = (props: { disabled?: boolean; imageUrl: string; isImageHidden?: boolean }) => {
    const { imageUrl, disabled, isImageHidden } = props;

    return (
        <div className="text-center">
            <button
                type="button"
                className="btn p-0 opacity-100"
                data-bs-toggle="modal"
                disabled={disabled}
                data-bs-target="#modal-stimulus"
                aria-label="View image"
            >
                <img alt="" src={imageUrl} className={clsx("img-fluid", isImageHidden && "blur")} />
            </button>
        </div>
    );
};

export const ImagePreviewModal = (props: { isImageHidden?: boolean; imageUrl: string }) => {
    const { isImageHidden, imageUrl } = props;

    return (
        <ModalDialog id="modal-stimulus" title="Stimulus image" size="lg">
            <div className="text-center">
                <img alt="" className={clsx("img-fluid", isImageHidden && "blur")} src={imageUrl} />
            </div>
        </ModalDialog>
    );
};
